module.exports = __webpack_public_path__ + "static/img/img1.4d3daeb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cooperation_case/img1.png
// module id = uJiP
// module chunks = 0